import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { zodValidator } from '@tanstack/zod-adapter'
import { NewCanvasPage } from '@/components/pages/NewCanvasPage'

const newCanvasSearchSchema = z.object({
  projectId: z.string().optional(),
})

export const Route = createFileRoute('/canvas/new')({
  validateSearch: zodValidator(newCanvasSearchSchema),
  component: NewCanvasPage,
})
